import { NameFormat } from '@tractable/estimating-local-localization/lib/locales/types';

type NameParts = {
	firstName: string;
	lastName: string;
};

export const formatName = (nameFormat: NameFormat, { firstName, lastName }: NameParts) =>
	nameFormat.replace('<firstName>', firstName).replace('<lastName>', lastName);
